"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableContentControlMemoized = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _handlers = require("../../../helpers/handlers");
var _RenderWhen = _interopRequireDefault(require("../../RenderWhen"));
var _CircleLoader = _interopRequireDefault(require("../CircleLoader"));
var _Input = _interopRequireDefault(require("../Input"));
var _Button = _interopRequireWildcard(require("../Button"));
var _check = _interopRequireDefault(require("./img/check.svg"));
var _close = _interopRequireDefault(require("./img/close.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var noop = function noop() {};
var defaultValueTransformer = function defaultValueTransformer(value) {
  return value;
};
var EditableContentControl = function EditableContentControl(_ref) {
  var className = _ref.className,
    _ref$editing = _ref.editing,
    editing = _ref$editing === void 0 ? false : _ref$editing,
    _ref$value = _ref.value,
    initialEditingValue = _ref$value === void 0 ? '' : _ref$value,
    _ref$getIsValidValue = _ref.getIsValidValue,
    getIsValidValue = _ref$getIsValidValue === void 0 ? R.T : _ref$getIsValidValue,
    _ref$externalValueTra = _ref.externalValueTransformer,
    externalValueTransformer = _ref$externalValueTra === void 0 ? defaultValueTransformer : _ref$externalValueTra,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
    _ref$onConfirm = _ref.onConfirm,
    onConfirm = _ref$onConfirm === void 0 ? noop : _ref$onConfirm;
  var _useState = (0, _react.useState)(initialEditingValue),
    _useState2 = _slicedToArray(_useState, 2),
    editingValue = _useState2[0],
    setEditingValue = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isNeedOnBlur = _useState4[0],
    setIsNeedOnBlur = _useState4[1];
  var onConfirmProxy = function onConfirmProxy() {
    return onConfirm(editingValue);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, /*#__PURE__*/_react.default.createElement(_RenderWhen.default, null, /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: editing
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_CircleLoader.default, null))), /*#__PURE__*/_react.default.createElement(_RenderWhen.default.If, {
    isTrue: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.editingContainer,
    onClick: (0, _handlers.handleWith)(_handlers.stop, _handlers.prevent)
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    autoFocus: true,
    className: (0, _classnames2.default)(_styles.default.editingInput, _defineProperty({}, _styles.default.error, !editingValue)),
    hasError: Boolean(!editingValue),
    value: editingValue,
    onBlur: isNeedOnBlur ? onConfirmProxy : undefined,
    onChange: function onChange(value) {
      if (getIsValidValue(value)) {
        var processedValue = externalValueTransformer(value);
        setEditingValue(processedValue);
      }
    },
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' && onConfirmProxy();
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttonWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    icon: _check.default,
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.PURPLE,
    onClick: onConfirmProxy,
    onMouseEnter: function onMouseEnter() {
      return setIsNeedOnBlur(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsNeedOnBlur(true);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttonWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: _styles.default.close,
    width: _Button.WIDTHS.FLUID,
    height: _Button.HEIGHTS.FLUID,
    icon: _close.default,
    size: _Button.SIZES.TINY,
    theme: _Button.THEMES.WHITE,
    onClick: function onClick() {
      onClose();
    },
    onMouseEnter: function onMouseEnter() {
      return setIsNeedOnBlur(false);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsNeedOnBlur(true);
    }
  })))))));
};
EditableContentControl.propTypes = {
  className: _propTypes.default.string,
  editing: _propTypes.default.bool,
  value: _propTypes.default.string,
  getIsValidValue: _propTypes.default.func,
  externalValueTransformer: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onConfirm: _propTypes.default.func
};
var EditableContentControlMemoized = exports.EditableContentControlMemoized = (0, _react.memo)(EditableContentControl);